import { useContext } from "react";
import styled from "styled-components";
import CustomButton from "../../../helperComponents/CustomButton";
import { FaEdit } from "react-icons/fa";
import getImageURL from "../../../../controllers/getImageURL";
import goTo from "../../../../controllers/goTo";
import { GrDocument, GrLocation } from "react-icons/gr";
import {
  MdOutlinePhoneEnabled,
  MdOutlineRadioButtonUnchecked,
} from "react-icons/md";
import BubbleTextForCard from "../../../customUiForCs/BubbleTextForCard";
import Context from "../../../../Context";
import IconWithTextForCard from "../../../customUiForCs/IconWithTextForCard";
import CardForItem from "../../../customUiForCs/CardForItem";
import { BsPeople } from "react-icons/bs";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 10px;
  color: var(--elementDim);
  width: 100%;
  gap: 10px;
  cursor: pointer;
  /* position: relative; */

  align-items: center;

  &:hover {
    background: var(--surface);
  }
`;

const Image = styled.img`
  height: 100px;
  width: 100px;
  border-radius: 10px;
  object-fit: cover;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  flex: 1;
`;

const PrimaryLine = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const SecondaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  margin-top: -3px;
`;

const TertiaryLine = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
`;

const Name = styled.div`
  font-size: 21px;
  font-weight: 900;
  color: var(--element);
`;

const BubbleText = styled.div`
  background-color: var(--surface);
  padding: 5px 12px;
  color: var(--element);
  border-radius: 15px;
  text-transform: capitalize;
`;

const TertiaryText = styled.div``;

const PrimaryInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: pointer;
`;

const Buttons = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
`;

const VirtualCard = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

export default function SiteCard({ data }) {
  const { t } = useTranslation();
  const contractCount =
    (data.contracts ? data.contracts.length : 0) +
    (data.holidayStaff ? data.holidayStaff.length : 0);

  return (
    <CardForItem
      makeRed={!data.isActive}
      itemType={"SITE"}
      pagePath="site"
      itemID={data._id}
      editPath={"edit-site"}
      image={data.image}
      title={`${data.placeName} ${data.codename ? " - " + data.codename : ""}`}
      bubbleTexts={[data.clientName]}
      line1={[
        {
          icon: <GrLocation />,
          text: data.zoneName ? data.zoneName : `${t("Zone")} : Non`,
        },
        {
          icon: <BsPeople />,
          text: `Personnel : ${data.personnelCount}`,
        },
        {
          icon: <GrDocument />,
          text: `${contractCount} Contrats`,
        },
        // {
        //   icon: <MdOutlineRadioButtonUnchecked />,
        //   text: data.assistance
        //     ? `${data.assistance.length} Assistance`
        //     : "0 Contracts",
        // },
      ]}
      line2={data.contacts.map(
        (item) =>
          item.phoneNumber && {
            icon: <MdOutlinePhoneEnabled />,
            text: `${item.phoneNumber} ( ${item?.clientName?.trim()} ) `,
          }
      )}
    />
  );
}
